/*
 * Gravure diamant Wusaki — comportement de snippets/wusaki-gravure.liquid.
 *
 * Mode « couteau » : la case à cocher déplie le texte et la police, le bouton ajoute le produit
 * gravure au panier en AJAX, avec 3 propriétés dont les noms viennent du thème (traduits).
 * Mode « formulaire » : les champs sont déjà dans le formulaire d'ajout (form="…", required),
 * le navigateur bloque l'envoi tant qu'ils sont vides ; rien à faire ici.
 *
 * Chargé globalement par layout/theme.liquid : l'élément doit aussi s'initialiser quand la
 * quick-view injecte la fiche après coup.
 */
if (!customElements.get('wusaki-gravure')) {
  class WusakiGravure extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'couteau' || this.initialise) return;
      this.initialise = true;

      this.check = this.querySelector('[data-wg-check]');
      this.fields = this.querySelector('[data-wg-fields]');
      this.msg = this.querySelector('[data-wg-msg]');
      this.indispo = this.querySelector('[data-wg-indispo]');
      this.dispo = {};
      try {
        this.dispo = JSON.parse(this.querySelector('[data-wg-variants]').textContent);
      } catch (e) {}

      this.majDispo();
      this.check.addEventListener('change', () => {
        this.fields.classList.toggle('is-open', this.check.checked);
      });
      this.querySelector('[data-wg-add]').addEventListener('click', () => this.ajouter());

      // Changement de variante du couteau : événement du thème, et repli sur le champ id.
      if (window.FoxTheme && FoxTheme.pubsub) {
        this.desabonner = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, () =>
          this.majDispo()
        );
      }
      this.surChangement = (event) => {
        if (event.target && event.target.name === 'id') this.majDispo();
      };
      document.addEventListener('change', this.surChangement);
    }

    disconnectedCallback() {
      if (this.desabonner) this.desabonner();
      if (this.surChangement) document.removeEventListener('change', this.surChangement);
    }

    /* Variante actuellement sélectionnée sur la fiche */
    variantCourant() {
      const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return String(input.value);
      return new URLSearchParams(location.search).get('variant') || Object.keys(this.dispo)[0];
    }

    couteauDispo() {
      return this.dispo[this.variantCourant()] !== false;
    }

    majDispo() {
      const ok = this.couteauDispo();
      this.indispo.hidden = ok;
      this.check.disabled = !ok;
      this.classList.toggle('is-indispo', !ok);
      if (!ok && this.check.checked) {
        this.check.checked = false;
        this.fields.classList.remove('is-open');
      }
    }

    ajouter() {
      if (!this.couteauDispo()) {
        this.majDispo();
        return;
      }
      const texte = this.querySelector('[data-wg-texte]').value.trim();
      if (!texte) {
        this.msg.textContent = this.dataset.msgTexte;
        return;
      }
      const properties = {};
      properties[this.dataset.cleTexte] = texte;
      properties[this.dataset.clePolice] = this.querySelector('[data-wg-police]').value;
      properties[this.dataset.cleCouteau] = this.dataset.couteau;

      fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(this.dataset.variant, 10), quantity: 1, properties }] }),
      })
        .then((r) => {
          if (!r.ok) throw new Error(String(r.status));
          return r.json();
        })
        .then(() => {
          this.msg.innerHTML = this.dataset.msgAjoute;
          return this.rafraichirPanier();
        })
        .catch(() => {
          this.msg.textContent = this.dataset.msgErreur;
        });
    }

    /* Compteur et tiroir panier : le tiroir (assets/cart.js) se recharge et publie cartUpdate.
       Tiroir laissé fermé : le client doit encore ajouter le couteau depuis la fiche. */
    rafraichirPanier() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
    }
  }
  customElements.define('wusaki-gravure', WusakiGravure);
}
